import React, { ReactElement } from 'react';
import { SvgIcon } from '@material-ui/core';
import { CancelRounded } from '@material-ui/icons';
import BasicModal from '../../../../modules/modals/BasicModal';
import JoinActionButton from '../../JoinActionButton';
import JoinSkipButton from '../../JoinSkipButton';
import colors from '../../../../theme/colors';
import {
  ConfirmDescription,
  Headline,
  HeadlineContainer,
  HelpContainer,
  NotesSubtitle,
  NotesTitle,
  StyledContainer,
  confirmModalStyle,
  helpContainerCustomStyle,
  selfieWallContentStyle,
} from '../SelfieVerificationStyle';
import { CloseBtn, closeButton } from '../../../common/CommonStyle';
import useMediaBreakpoints from '../../../../hooks/useMediaBreakpoints';
import WarningIcon from '../../../../atoms/icons/WarningIcon';

interface ConfirmationModalProps {
  showConfirmModal: boolean;
  handleNevermindClick: () => void;
  handleClose: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  showConfirmModal,
  handleNevermindClick,
  handleClose,
}): ReactElement => {
  const { isMobile } = useMediaBreakpoints();

  return (
    <>
      <BasicModal
        isOpen={showConfirmModal}
        hideClose={true}
        customStyle={confirmModalStyle}
        customContentStyle={selfieWallContentStyle}
        onClose={handleClose}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
      >
        <CloseBtn
          onClick={handleClose}
          style={{ top: isMobile ? '-50px' : '-25px', right: isMobile ? '-18px' : '-42px' }}
        >
          <SvgIcon component={CancelRounded} style={closeButton} />
        </CloseBtn>
        <HeadlineContainer isJoinFlow={false}>
          <WarningIcon style={{ marginBottom: 10 }} />
          <Headline style={{ fontSize: '22px', textAlign: 'center' }}>
            Are you sure you want to skip the verification?
          </Headline>
          <ConfirmDescription style={{ display: isMobile ? 'none' : 'inherit' }}>
            Skipping this now will prevent you from interacting with other members.
          </ConfirmDescription>
        </HeadlineContainer>
        <StyledContainer>
          <HelpContainer customStyle={helpContainerCustomStyle}>
            <NotesTitle isJoinFlow={false}>Please remember!</NotesTitle>
            <NotesSubtitle isJoinFlow={false}>
              Your selfie is private and will NOT be shown on your profile.
            </NotesSubtitle>
          </HelpContainer>

          <div style={{ textAlign: 'center' }}>
            <JoinActionButton
              label={`Start Selfie Verification`}
              isDefault={true}
              onClick={handleNevermindClick}
              customStyle={{ marginBottom: 20, width: 'auto' }}
            />

            <JoinSkipButton
              label={`I'm sure, let's skip for now`}
              onClick={handleClose}
              customStyle={{ fontSize: 14, lineHeight: '17px', color: colors.gray['1100'] }}
            />
          </div>
        </StyledContainer>
      </BasicModal>
    </>
  );
};

export default ConfirmationModal;
